export default __webpack_public_path__ + "static/media/jqeury.6d21b03d.png";